export default "__VITE_ASSET__814be546__"